module.exports = __webpack_public_path__ + "img/saved.3aaaedef.svg";